var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg333(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "333 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect18",
    d: "M145.113 29.4915H29.0563V145.549H145.113V29.4915Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect20",
    d: "M307.593 29.4915H191.536V145.549H307.593V29.4915Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect22",
    d: "M470.073 29.4915H354.016V145.549H470.073V29.4915Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect24",
    d: "M145.694 191.971H29.6366V308.029H145.694V191.971Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect26",
    d: "M308.174 191.971H192.117V308.029H308.174V191.971Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect28",
    d: "M470.654 191.971H354.596V308.029H470.654V191.971Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect30",
    d: "M145.984 354.451H29.9267V470.508H145.984V354.451Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect32",
    d: "M308.464 354.451H192.407V470.508H308.464V354.451Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect34",
    d: "M470.944 354.451H354.887V470.508H470.944V354.451Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg333);
export default __webpack_public_path__ + "static/media/333.83d33c9e6e762100190155bea7c2474c.svg";
export { ForwardRef as ReactComponent };